export const EMR_BUILD_VERSION = '7-02-2025-13:23';

export interface CustomerInfo {
  id: string;
  www: string;
  logo: string;
  emailDomains: string[];
}

const customerCalvin: CustomerInfo = {
  id: 'Calvin University',
  www: 'https://www.calvin.edu',
  logo: 'assets/logos/calvin-university-1876-inverse.png',
  emailDomains: [
    'calvin.edu',
    'students.calvin.edu',
  ],
};
const customerGVSU: CustomerInfo = {
  id: 'Grand Valley State University',
  www: 'https://www.gvsu.edu',
  logo: 'assets/logos/gvsu_logo_blue.svg',
  emailDomains: [
    'gvsu.edu',
  ],
};

export const customer: CustomerInfo = customerCalvin;

// export const customer = 'GVSU';
// export const customer = 'Davenport';